export default {
    module: 'views/footer'
};
